import * as React from 'react';
import styled from 'styled-components';
import { ButtonBaseThemed, ButtonProps } from '@packages/ui';

const StyledMessageBannerButton = styled(ButtonBaseThemed).attrs({ 'data-testid': 'message-banner-button' })`
  min-height: 40px;
  height: auto;
  white-space: normal;
  line-height: 2rem;
`;

export const MessageBannerButton: React.FC<ButtonProps> = React.forwardRef((props, ref) => {
  const {
    children,
    variant = 'primary',
    block = false,
    noShadow = false,
    type = 'button',
    as = 'button',
    disabled = false,
    ...buttonProps
  } = props;
  return (
    <StyledMessageBannerButton
      {...buttonProps}
      ref={ref}
      as={as as any}
      type={type}
      disabled={disabled}
      variant={variant}
      noShadow={noShadow}
      block={block}
    >
      {children}
    </StyledMessageBannerButton>
  );
});

MessageBannerButton.displayName = 'MessageBannerButton';
